export interface UserRoleNotifications {
  businessGoalReached: boolean;
  businessHealthAlert: boolean;
  businessTwoMonthGoalReached: boolean;
  businessStatusUpdate: boolean;
  businessFailingGoals: boolean;
  businessNewLeadReceived: boolean;
  businessClientUploadReminder: boolean;
  rollthroughReports: boolean;
  creativeHubAdApproved: boolean;
  creativeHubAdRejected: boolean;
  creativeHubAdPending: boolean;
}

export const exampleUserRoleNotifications: UserRoleNotifications = {
  businessGoalReached: false,
  businessHealthAlert: false,
  businessTwoMonthGoalReached: false,
  businessStatusUpdate: false,
  businessFailingGoals: false,
  businessNewLeadReceived: false,
  rollthroughReports: false,
  creativeHubAdApproved: false,
  creativeHubAdRejected: false,
  creativeHubAdPending: false,
  businessClientUploadReminder: false,
};
